import 'owl.carousel';
import 'slick-carousel';
import 'jquery-validation';
import 'jquery-ui/ui/widgets/datepicker';
import 'jquery-ui/ui/i18n/datepicker-es';
var Sticky = require('sticky-js');
import L from 'leaflet';

$('.card-slider').owlCarousel({
    loop: true,
    nav: false,
    items: 1,
    smartSpeed: 1000,
    dotsSpeed: 1000,
    autoplay: false,
    autoplayTimeout: 5000,
    autoplayHoverPause: false,
});

$('.fixed-slider').owlCarousel({
    loop: true,
    nav: false,
    items: 1,
    smartSpeed: 1000,
    dotsSpeed: 1000,
    autoplay: false,
    autoplayTimeout: 5000,
    autoplayHoverPause: false,
});

$('.slider-phrase').owlCarousel({
    loop: true,
    nav: false,
    items: 1,
    smartSpeed: 1000,
    dotsSpeed: 1000,
    autoplay: false,
    autoplayTimeout: 5000,
    autoplayHoverPause: false,
});

$('.tabs-section .box').on('click',function() {
    var index = $('.tabs-section .box').index(this);

    $('.tabs-section .box').not(this).removeClass('active');
    $(this).addClass('active');
    $('.wrapper-items .item').fadeOut(0);
    $('.wrapper-items .item').eq(index).fadeIn(0);
});

$('.view').on('click', function(e){
    e.preventDefault();
    $('.modal-document').fadeIn(300).css('display', 'flex');
    var view_url = $(this).attr('data-view');
    var view_title = $(this).attr('data-title');
    $('.modal-document iframe').attr('src',view_url);
    $('.modal-document .title h2').text(view_title);
});

$('.modal-document .cap-close').on('click', function(e){
    $('.modal-document').fadeOut(0);
    $('.modal-document iframe').attr('src','');
});

$('.video-play').on('click', function(e){
    e.preventDefault();
    $('.modal-video').fadeIn(300).css('display', 'flex');
    var view_url = $(this).attr('data-view');
    $('.modal-video iframe').attr('src',view_url);
});

$('.modal-video .cap-close').on('click', function(e){
    $('.modal-video').fadeOut(0);
    $('.modal-video iframe').attr('src','');
});

if($(window).width() > 980) {
    var sticky = new Sticky('.parent-slider-fixed');
}

$('.slider-for').slick({
    arrows: true,
    prevArrow:"<span class='lnr lnr-arrow-left'></span>",
    nextArrow: "<span class='lnr lnr-arrow-right'></span>",
    asNavFor: '.slider-nav,.slider-x',
});
//$('.slider-for').slick('slickGoTo', 1);
$('.slider-x').slick({
    arrows: false,
    asNavFor: '.slider-for,.slider-nav',
});
//$('.slider-x').slick('slickGoTo', 1);
$('.slider-nav').slick({
    arrows: false,
    asNavFor: '.slider-for,.slider-x',
    centerMode: false,
    centerPadding: '60px',
    dots: false,
    focusOnSelect: true,
    slidesToShow: 2,
});

$.validator.addMethod("names", function (value, element) {
    let pattern = /^[A-Za-zÀ-ÿ\\u00f1\\u00d1][A-Za-zÀ-ÿ\\u00f1\\u00d1 ]+$/;
    return this.optional(element) || pattern.test(value);
}, pllStrings.no_es_un_nombre_valido);

$.validator.addMethod("cell_phone", function (value, element) {
    let pattern = /^[+ 0-9]+$/ig;
    return this.optional(element) || pattern.test(value);
}, pllStrings.no_es_un_numero_valido);

let isContactForm = false;

$('.contact-form').each( function(e){
    $(this).validate({
        ignore: [],
        errorPlacement: function(error, element) {
            if (error.text() != '') {
                element.parents('.form-group').next('.msn').fadeIn(0).text(error.text());
                element.addClass("is-invalid");
                //$('input, textarea').placeholder();
            }
        },
        unhighlight: function (element) {
            $(element).removeClass("is-invalid");
            $(element).parents('.form-group').next('.msn').fadeOut(0).text('');
        },
        success : function(label, element){
            $(element).removeClass("is-invalid");
            $(element).parents('.form-group').next('.msn').fadeOut(0).text('');
        },
        rules: {
            area: {
                required: true
            },

            name: {
                required: true,
                names:true
            },
            email: {
                required: true,
                email: true
            },
            subject: {
                required: true
            },
            message: {
                required: true
            },
        },
        messages: {
            area: {
                required: pllStrings.este_campo_es_requerido,
            },

            name: {
                required: pllStrings.este_campo_es_requerido,
            },
            email: {
                required: pllStrings.este_campo_es_requerido,
                email: pllStrings.el_correo_no_es_valido,
            },
            subject: {
                required: pllStrings.este_campo_es_requerido,
            },
            message: {
                required: pllStrings.este_campo_es_requerido,
            }
        },
        submitHandler: function(form) {

            if (isContactForm || !$('#area-select-form').valid()) return;
            isContactForm = true;
        
            let $this = $(form);
            let formData = new FormData(form);
            let areaFormData = new FormData($('#area-select-form').get(0));
            
            for (let item of areaFormData.entries()) {
                formData.append(item[0], item[1]);
            }
        
            fetch($this.attr('action'), {
                method: $this.attr('method'),
                body: formData
            })
            .then(function (response) {
                return response.json();
            }).then(function (response) {
                if (response.success) {
                    $('.parent-section-form').fadeOut(0);
                    $('.wrapper-thanks').fadeIn(0);
                    $("html, body").animate({ scrollTop: "0" });

                    $this.trigger('reset');
                }
                
                isContactForm = false;
            }).catch(function (err) {
                isContactForm = false;
            });
        }
    });
});

$('#area-select-form').validate({
    ignore: [],
    errorPlacement: function(error, element) {

        if (error.text() != '') {
            element.parents('.select-style').next('.msn').fadeIn(0).text(error.text());
            element.addClass("is-invalid");
            //$('input, textarea').placeholder();
        }
    },
    unhighlight: function (element) {
        $(element).removeClass("is-invalid");
        $(element).parents('.select-style').next('.msn').fadeOut(0).text('');
    },
    success : function(label, element){
        $(element).removeClass("is-invalid");
        $(element).parents('.select-style').next('.msn').fadeOut(0).text('');
    },
    rules: {
        area: {
            required: true
        }
    },
    messages: {
        area: {
            required: pllStrings.este_campo_es_requerido,
        },
    },

    submitHandler: function(form) {
        return false;
    }
});

$('#contact-form .btn-green').on('click', function() {
    $('#area-select-form').valid();
})

$('#area-select-form #area').on('change', function() {
    $('#area-select-form').valid();
});

let isLoginForm = false;
$('#login-form').each( function(e){
    $(this).validate({
        ignore: [],
        errorPlacement: function(error, element) {
            if (error.text() != '') {
                element.parents('.form-group').next('.msn').fadeIn(0).text(error.text());
                element.addClass("is-invalid");
                //$('input, text1').placeholder();
            }
        },
        unhighlight: function (element) {
            $(element).removeClass("is-invalid");
            $(element).parents('.form-group').next('.msn').fadeOut(0).text('');
        },
        success : function(label, element){
            $(element).removeClass("is-invalid");
            $(element).parents('.form-group').next('.msn').fadeOut(0).text('');
        },
        rules: {
            nit: {
                required: true
            }
        },
        messages: {
            nit: {
                required: pllStrings.este_campo_es_requerido,
            }
        },
        submitHandler: function(form) {
            $('.ajax-message').text('').hide();

            if (isLoginForm) return;
            isLoginForm = true;
        
            let formData = new FormData(form);
            let nit = $(form).find('#login_nit').val();

            $('#otp-validation-form #otp_nit').val(nit);

            fetch($(form).attr('action'), {
                method: $(form).attr('method'),
                body: formData
            })
            .then(function (response) {
                return response.json();
            }).then(function (response) {
                if (response.success) {
                    //$(form).trigger('reset');
                    $('#login-form, #otp-validation-form').toggle();
                    $('.code-message').show();
                } else if (typeof response.data.message !== 'undefined') {
                    $('.ajax-message').text(response.data.message).show();
                }
                
                isLoginForm = false;
            }).catch(function (err) {
                isLoginForm = false;
            });
        }
    });
});

let isOtpValidationForm = false;
$('#otp-validation-form').each( function(e){
    $(this).validate({
        ignore: [],
        errorPlacement: function(error, element) {
            if (error.text() != '') {
                element.parents('.form-group').next('.msn').fadeIn(0).text(error.text());
                element.addClass("is-invalid");
            }
        },
        unhighlight: function (element) {
            $(element).removeClass("is-invalid");
            $(element).parents('.form-group').next('.msn').fadeOut(0).text('');
        },
        success : function(label, element){
            $(element).removeClass("is-invalid");
            $(element).parents('.form-group').next('.msn').fadeOut(0).text('');
        },
        rules: {
            code: {
                required: true
            },

            nit: {
                required: true
            }
        },
        messages: {
            code: {
                required: pllStrings.este_campo_es_requerido,
            },

            nit: {
                required: pllStrings.este_campo_es_requerido,
            }
        },
        submitHandler: function(form) {
            $('.ajax-message').text('').hide();

            $('.code-message').hide();

            if (isOtpValidationForm) return;
            isOtpValidationForm = true;
        
            let $this = $(form);
            let formData = new FormData(form);
            
            fetch($this.attr('action'), {
                method: $this.attr('method'),
                body: formData
            })
            .then(function (response) {
                return response.json();
            }).then(function (response) {
                if (response.success) {
                    //$this.trigger('reset');
                    //window.location = location.href;

                    if (typeof response.data.redirect_to !== 'undefined') window.location = response.data.redirect_to;
                } else if (typeof response.data.message !== 'undefined') {
                    $('.ajax-message').text(response.data.message).show();
                }
                
                isOtpValidationForm = false;
            }).catch(function (err) {
                isOtpValidationForm = false;
            });
        }
    });
});

$('.mobile-link').on('click', function(e) {
    e.preventDefault();
    $('header .wrapper').fadeIn(300).css('display', 'flex');
});

$('.close-mobile-link').on('click', function(e) {
    e.preventDefault();
    $('header .wrapper').fadeOut(300);
});

$('.pll-language').on('change', function(e) {
    location.href = $(this).val();
});

$(function() {
    if (!window.location.hash || $('#contact-form').length == 0 || $('#area').length == 0) return;

    let hash = window.location.hash.substring(1);
    let selectedText = decodeURI(hash).trim();

    $("select#area option").filter(function() {
        return $(this).text().trim() == selectedText;
      }).prop('selected', true);
});

//Dashboard page
$('.report-items').on('click', '.pagination a', function(e) {
    e.preventDefault();

    
    getReports($(this).closest('.item'), {
        'page':$(this).data('page')
    });
});

//Shop page
$('.shop-items').on('click', '.pagination a', function(e) {
    e.preventDefault();

    getProducts({
        'page':$(this).data('page')
    });
});

$('.page-general__shop #all-categories').on('change', function(e) {
    e.preventDefault();

    let wrapper = $(this).closest('.wrapper-checkbox');
    let isChecked =  $(this).is(':checked');

    wrapper.find('input[type=checkbox]').prop('checked', isChecked);

    getProducts({
        'page': 1,
    });
});

$('.page-general__shop .categories').on('change', function(e) {
    e.preventDefault();

    getProducts({
        'page': 1,
    });
});

function getProducts(params = {}) {
    $('.shop-items').html('');

    let formData = new FormData(document.querySelector('#category-filter'));

    for (let key in params ) {
        formData.append(key, params[key]);
    }

    fetch(wpAjaxUrl, {
        method: 'POST',
        body: formData
    })
    .then(function (response) {
        return response.text();
    }).then(function (html) {
        $('.shop-items').html(html);
    }).catch(function (err) {
        $('.shop-items').html(html);
    });
}

function getReports(item, params = {}) {
    $(item).html('');

    let termId = item.data('termId');
    let formData = new FormData();

    let date = $('#datepicker').val()
    console.log('#date', date);

    formData.append('action', 'async_html_reports');
    formData.append('term_id', termId);
    formData.append('lang', currentLanguage);

    console.log('#date', date);


    if (date) formData.append('date', date);

    for (let key in params ) {
        formData.append(key, params[key]);
    }

    fetch(wpAjaxUrl, {
        method: 'POST',
        body: formData
    })
    .then(function (response) {
        return response.text();
    }).then(function (html) {
        $(item).html(html);
    }).catch(function (err) {
        $(item).html(html);
    });
}

$('#date-report-filter').on('click', function(e) {
    e.preventDefault();

    let items = $('.report-items .item');
    console.log('#items', items);

    $.each(items, function(index, element) {
        getReports($(element))
    });
});

$('#date-clear-filter').on('click', function(e) {
    e.preventDefault();

    $('.date-picker').val('');
    $('#date-report-filter').trigger('click');
});

function socialWindow(url) {
    var left = (screen.width - 570) / 2;
    var top = (screen.height - 570) / 2;
    var params = "menubar=no,toolbar=no,status=no,width=570,height=570,top=" + top + ",left=" + left;
  
    window.open(url,"NewWindow",params);
}
  
$(".social").on("click", '.facebook', function(e) {
    e.preventDefault();

    let url = "https://www.facebook.com/sharer.php?u=" + $(this).attr('href');
    socialWindow(url);
});

$(".social").on("click", '.twitter', function(e) {
    e.preventDefault();

    let url = "https://twitter.com/intent/tweet?url=" + $(this).attr('href');
    socialWindow(url);
});

$('.copy-href-to-clipboard').on('click', function (e) {
    e.preventDefault();

    var copyText = $(this).attr('href');
    document.addEventListener('copy', function(e) {
       e.clipboardData.setData('text/plain', copyText);
       e.preventDefault();
    }, true);
    
    $(this).append( "<small>¡Copiado!</small>" );

    setTimeout(function() {
        $this.find("small").remove();
    },1500);
    
    document.execCommand('copy');
});

if ( $('#mapid').length ) {
    var map = L.map('mapid',{
        scrollWheelZoom: false,
        boxZoom: false,
        trackResize: false,
        doubleClickZoom: false,
        dragging: false,
        zoomControl: false,
    }).setView([7.7565083, -76.6616363], 16);
    L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoiZGFuaWVseWwxMjMiLCJhIjoiY2t2MnhjeGkxNzBhbTJ2dDk2eXg4OGR5eCJ9.tN3Wf9ObG7_cP1OR0__isQ', {
        attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, ' +
            'Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
        id: 'mapbox/streets-v11',
        tileSize: 512,
        zoomOffset: -1,
    }).addTo(map);
    L.marker([7.7565083, -76.6616363]).addTo(map).bindPopup('BIOPLANTA S.A')
    .openPopup();
}

$('#datepicker').datepicker({
    changeMonth: true,
    changeYear: true,
    showButtonPanel: true,
    dateFormat: 'yy-mm',
    
    beforeShow: function(input, inst) {
        var datestr;
        var year;
        var month;

        datestr = $(this).val();

        year = datestr.substring(0, 4);
        month = datestr.substring(5, 7);
        
        $(this).datepicker('option', 'defaultDate', new Date(year, month - 1, 1));
    },

    onChangeMonthYear: function(year, month, inst) {
        $(this).datepicker('setDate', new Date(year, month - 1, 1));
    },
    
    onClose: function(dateText, inst) {
      $(this).datepicker('setDate', new Date(inst.selectedYear, inst.selectedMonth, 1));
    }
});

